<h6 class="p-2 mb-0" [ngClass]="{ 'teal-background white-font uppercase': showHeader, 'no-header px-3': !showHeader }">
  Prepaid Clinic Supplies
</h6>
<div class="px-2">
  <ngx-loading [show]="loading"></ngx-loading>
  <div *ngIf="prepaidClinicSupplies.length === 0" class="pb-2 px-2">
    <p class="m-0">No prepaid clinic supplies</p>
  </div>
  <div
    class="d-flex grey-two-background mb-2 justify-content-between align-items-center"
    *ngFor="let supply of prepaidClinicSupplies"
  >
    <div class="py-2 px-2 navy-font">
      <span class="font-weight-bold">{{ supply.supplyName }}</span>
    </div>
    <div class="ml-auto panel-box-column px-2 bigger font-weight-bold teal-font">
      {{ supply.remainingQuantity | number : '1.0-2' }} {{ supply.unitName }}
    </div>
  </div>
</div>
